import { HardwareRequestStatus } from "src/api/types.generated";

export const HACKER_STATUS_MAP: Record<HardwareRequestStatus, string> = {
  [HardwareRequestStatus.Waiting]: "Waiting",
  [HardwareRequestStatus.Requested]: "Requested",
  [HardwareRequestStatus.Accepted]: "Accepted",
  [HardwareRequestStatus.PickedUp]: "Picked Up",
  [HardwareRequestStatus.Denied]: "Denied",
  [HardwareRequestStatus.Returned]: "Returned",
  [HardwareRequestStatus.Ready]: "Ready",
  [HardwareRequestStatus.Cancelled]: "Cancelled",
};

export const TIMELINE_FIELDS = [
  { key: "requested_at", label: "Requested" },
  { key: "accepted_at", label: "Accepted" },
  { key: "ready_at", label: "Ready" },
  { key: "picked_up_at", label: "Picked Up" },
  { key: "returned_at", label: "Returned" },
  { key: "denied_at", label: "Denied" },
  { key: "cancelled_at", label: "Cancelled" },
] as const;
